import React from 'react';
import {Hero} from "../../components/hero/Hero";
import {NewsListSection} from "../../components/news/NewsListSection";
import {SectionHeader} from "../../components/section-header/SectionHeader";
import {ItemGroup} from "../../components/item-group/ItemGroup";
import {ListLayout} from "../../components/layout/ListLayout";
import {GridContentItem} from "../../components/item/GridContentItem";
import {BasicContentItem} from "../../components/item/BasicContentItem";

import {ContactUsRawInfo} from "../../components/contact-us/ContactUsRawInfo";
import {connect} from "react-redux";
import {WorkWithUs} from "../../components/contact-us/WorkWithUs";
import {BasicAnimation} from "../../components/animations/BasicAnimation";

import {Helmet} from "react-helmet";

class AboutUsViewContainer extends React.Component {

  constructor(props) {
    super(props);

    let state = {};

    try {
      state.heroTitle = this.props.aboutPage.acf.obx_hero_title;
      state.heroLead = this.props.aboutPage.acf.obx_hero_lead;
      state.introTitle = this.props.aboutPage.acf.obx_introduction_title;
      state.introLead = this.props.aboutPage.acf.obx_introduction_lead;
      state.threeValues = [
        {
          title: this.props.aboutPage.acf.obx_mission_title,
          text: this.props.aboutPage.acf.obx_mission_text
        },
        {
          title: this.props.aboutPage.acf.obx_vision_title,
          text: this.props.aboutPage.acf.obx_vision_text
        },
        {
          title: this.props.aboutPage.acf.obx_values_title,
          text: this.props.aboutPage.acf.obx_values_text
        }
      ]
    } catch(e) {}

    try {
      state.heroImage = this.props.aboutPage._embedded["wp:featuredmedia"][0].source_url;
    } catch(e) {}

    try {
      this.featureBlocksContent = this.props.aboutPage.acf.obx_feature_blocks_repeater.map((block, i) => (
        {
          title: block.obx_feature_block_title,
          content: block.obx_feature_block_body,
          image: block.obx_feature_block_image,
          color: i === 0,
          reverse: !(i % 2 === 0)
        }
      ));
    } catch(e) {
      this.featureBlocksContent = [];
    }

    try {
      this.contentBlocksContent = this.props.aboutPage.acf.obx_content_blocks_repeater.map((block, i) => (
        {
          title: block.obx_content_block_title,
          content: block.obx_content_block_body,
          image: block.obx_content_block_image
        }
      ));
    } catch(e) {
      this.contentBlocksContent = [];
    }

    this.state = { ...state };
  }


  render(){
    return (

      <div>

        <Helmet>
          <title>About Us | Obelux Aviation Lights</title>
          <meta name="description" content="The Number One Aviation Obstruction Light Manufacturer in The World."></meta>
          <meta name="og:description" content="The Number One Aviation Obstruction Light Manufacturer in The World."></meta>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <header>
          <Hero title={this.state.heroTitle}
                subtitle={this.state.heroLead}
                image={this.state.heroImage || require('../../assets/images/obelux-www-intro.jpg')}
                align="center"/>
        </header>
        <BasicAnimation duration={800} delay={0}>
          <SectionHeader align="center"
                         color="#fff"
                         title={this.state.introTitle}
                         subtitle={this.state.introLead}/>
        </BasicAnimation>
        <BasicAnimation duration={800} delay={300}>
          <ItemGroup layout={ ListLayout }
                     layoutAttributes={{ noGutters: true }}
                     item={ GridContentItem }
                     itemStyle="solution-style" data={this.featureBlocksContent}/>
        </BasicAnimation>
        <ItemGroup layout={ ListLayout }
                   full
                   layoutAttributes={{ noGutters: true }}
                   item={ BasicContentItem }
                   itemStyle="about-text-content" data={this.contentBlocksContent}/>
        <SectionHeader align="center"
                       color="#EEF1F4"
                       title={this.state.threeValues[0].title}
                       subtitle={
                         <span style={{textAlign: "center"}} className={"obelux-mission"}>{this.state.threeValues[0].text}</span>
                       }/>
        <SectionHeader align="center"
                       color="#EEF1F4"
                       title={this.state.threeValues[1].title}
                       subtitle={
                         <span style={{textAlign: "center"}} className={"obelux-mission"}>{this.state.threeValues[1].text}</span>
                       }/>
        <SectionHeader align="center"
                       color="#EEF1F4"
                       title={this.state.threeValues[2].title}
                       subtitle={
                         <span style={{textAlign: "center"}} className={"obelux-mission"}>{this.state.threeValues[2].text}</span>
                       }/>
        <ContactUsRawInfo/>
        <WorkWithUs/>
        <NewsListSection/>
      </div>
    );
  }
}

export const AboutUsView = connect(
  state => ({
    aboutPage: ( state.resolve.data && state.resolve.data.aboutPage ) || []
  })
)(AboutUsViewContainer);



// WEBPACK FOOTER //
// ./src/views/about-us/AboutUsView.js